import React from 'react';
import './bulletPoints.css';

const BulletPoints = () => {
    return (
       <ul className="benefits" aria-label="Key benefits">
  <li>
    <span className="benefits__icon" aria-hidden="true"></span>
    <span className="benefits__text">Bulk procurement made simple with transparent pricing, GST-compliant invoicing, and hassle-free reordering.</span>
  </li>
  <li>
    <span className="benefits__icon" aria-hidden="true"></span>
    <span className="benefits__text">Expert assistance to help you select the right products for patient care, workplace safety, and hygiene standards.</span>
  </li>
  <li>
    <span className="benefits__icon" aria-hidden="true"></span>
    <span className="benefits__text">Scalable solutions for single practices to multi-site institutions with consistent supply continuity.</span>
  </li>
</ul>

    );
};

export default BulletPoints;